import { render } from "./CadastroView.vue?vue&type=template&id=e62cf8e4&scoped=true"
import script from "./CadastroView.vue?vue&type=script&lang=js"
export * from "./CadastroView.vue?vue&type=script&lang=js"

import "./CadastroView.vue?vue&type=style&index=0&id=e62cf8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e62cf8e4"]])

export default __exports__